/* global axios */
import ApiClient from './ApiClient';

// SICARG MOD 6 — Panel del agente.
class SicargDashboardAPI extends ApiClient {
  constructor() {
    super('sicarg_dashboard', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new SicargDashboardAPI();
